import {
  Dialog,
  GenericSuspense,
  useTranslations,
  useUrlParamsValueToString,
} from "@harea/component";
import { useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const LateCreateContainer = () => {
  const [TITLE] = useTranslations(i18n);
  const navigate = useNavigate();
  const urlParamsToString = useUrlParamsValueToString();

  const handleClose = useCallback(() => {
    navigate(`..?${urlParamsToString}`);
  }, [urlParamsToString]);

  return (
    <Dialog open title={TITLE} onClose={handleClose} className="">
      <GenericSuspense>
        <Outlet />
      </GenericSuspense>
    </Dialog>
  );
};

export default LateCreateContainer;

const i18n = ["std_add"];
